module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-black-friday.c71fd8a9.jpg";